import React, { useCallback, useEffect, useState } from "react";
import styles from "./Home.module.css";
import Footer from "../../components/ui/Footer";
import Navbar from "../../components/ui/Navbar";
import Menu from "../../components/ui/Menu";
import Auth from "../../utils/api/Auth";
import { useDispatch, useSelector } from "react-redux";
import { userDataActions } from "../../store/redux-store/Index";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DistributoApi from "../../utils/api/DistributorApi";

function DistributorHome(props) {
  const [userDetails, setUserDetails] = useState([]);

  const [agentsStatus, setAgentStatus] = useState({
    agents: 0,
    dueSoon: 0,
    expired: 0,
  });

  const token = useSelector((state) => state.userData.loginData.token);

  const user = useSelector((state) => state.userData.personalInfo);

  const dispatch = useDispatch();

  const closeMenuHandler = () => {
    props.setShowMenu(false);
  };

  const fetchCustomers = useCallback(async () => {
    try {
      const response = await DistributoApi.getAllAgents({ token, page: 1 });
      const agentPage = response.data?.data;

      setAgentStatus((prevStatus) => ({
        ...prevStatus,
        agents: Number(agentPage?.total ?? 0),
      }));
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to fetch customers", error);
    }
  }, [token]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const userRes = await Auth.getUserInfo({ token: token });
        setUserDetails(userRes.data.user[0]);
        dispatch(userDataActions.generalUserData(userRes.data.user[0]));
      } catch (err) {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
          },
        });
      }
    };
    fetchUserDetails();
  }, [token, dispatch]);

  //   const checkagentsStatus = (date) => {
  //     const currentDate = new Date();
  //     const dueDate = new Date(date);

  //     if (dueDate < currentDate) {
  //       setAgentStatus((prevStatus) => ({
  //         ...prevStatus,
  //         expired: prevStatus.expired + 1,
  //       }));
  //     } else if (dueDate > currentDate) {
  //       setAgentStatus((prevStatus) => ({
  //         ...prevStatus,
  //         agents: prevStatus.agents + 1,
  //       }));
  //     } else if (dueDate - currentDate <= 30 * 24 * 60 * 60 * 1000) {
  //       setAgentStatus((prevStatus) => ({
  //         ...prevStatus,
  //         dueSoon: prevStatus.dueSoon + 1,
  //       }));
  //     }
  //   };

  const greetUser = () => {
    const currentTime = new Date().getHours();
    if (currentTime < 12) {
      return "Good Morning";
    } else if (currentTime < 18) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };

  return (
    <div>
      <ToastContainer />
      <div className="menu" onClick={closeMenuHandler}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      <Navbar title="Dashboard" setShowMenu={props.setShowMenu} />
      <div className={styles.body}>
        <div className={styles.body_inner}>
          <h1 className={styles.body_inner_header}>
            {greetUser()} {user?.fullname || userDetails?.fullname}.
          </h1>
          <div className={styles.body_inner_card}>
            <p className={styles.card_p}>Wallet</p>
            <h1 className={styles.card_h1}>
              ₦
              {user?.wallet?.balance || userDetails?.wallet?.balance
                ? Number(
                    userDetails?.wallet?.balance || user?.wallet?.balance
                  ).toLocaleString()
                : "0"}
            </h1>
            <p className={styles.card_p}>Sales progress for the month</p>
          </div>
        </div>

        <div className={styles.transaction}>
          <div
            className={styles.transaction_card}
            style={{ border: "1px solid #37CE7F" }}
          >
            <div
              className={styles.transaction_card_number}
              style={{ backgroundColor: "#37CE7F33" }}
            >
              <p style={{ color: "#03C962" }}>{agentsStatus?.agents}</p>
            </div>
            <div className={styles.transaction_card_text}>
              <h1>Agents</h1>
            </div>
          </div>

          <div
            className={styles.transaction_card}
            style={{ border: "1px solid #FBB31933" }}
          >
            <div
              className={styles.transaction_card_number}
              style={{ backgroundColor: "#FBB31933" }}
            >
              <p style={{ color: "#FBB319" }}>{agentsStatus?.dueSoon}</p>
            </div>
            <div className={styles.transaction_card_text}>
              <h1>Vehicles</h1>
            </div>
          </div>

          <div
            className={styles.transaction_card}
            style={{ border: "1px solid #FF0B0B" }}
          >
            <div
              className={styles.transaction_card_number}
              style={{ backgroundColor: "#FFCECE" }}
            >
              <p style={{ color: "#FF0B0B" }}>{agentsStatus?.expired}</p>
            </div>
            <div className={styles.transaction_card_text}>
              <h1>Total Balance</h1>
            </div>
          </div>
        </div>
        {/* <h1 className={styles.body_inner_header}>Coming Soon!</h1>
        <div className={styles.vehicle_products}>
          <div className={styles.vehicle_products_card}>Vehicle License</div>

          <div className={styles.vehicle_products_card}>Road Worth...</div>

          <div className={styles.vehicle_products_card}>Bill Payment</div>

          <div className={styles.vehicle_products_card}>Survey</div>
        </div> */}
      </div>
      <Footer />
    </div>
  );
}

export default DistributorHome;
